export const FETCH_INFO = 'FETCH_INFO';
export const FETCH_INFO_START = 'FETCH_INFO_START';
export const FETCH_INFO_SUCCESS = 'FETCH_INFO_SUCCESS';
export const FETCH_INFO_ERROR = 'FETCH_INFO_ERROR';
